import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import ProductGridItem from '../components/ProductGridItem';
import Modal from '../components/Modal';

export default class StaticCollection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.context = section.data.context;
    this.collectionUrl = this.context.collectionUrl;
    this.$focusItem = null;

    this.filtersContentSelector = '[data-productgrid-filters-content]';
    this.sortContent = '[data-productgrid-sort-content]';
    this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
    this.$sortTriggerButton = this.$el.find('[data-productgrid-trigger-sort-button]');
    this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
    this.$filtersTrigger = this.$el.find('[data-productgrid-trigger-filters]');
    this.$filtersContent = this.$el.find(this.filtersContentSelector);
    this.$allTags = this.$filtersContent.find('.filter-item a:not([data-filter-toggle])');
    this.$advandedTags = this.$el.find('[data-tag-advanced] a');
    this.$additionalTags = this.$el.find('[data-filter-toggle]');
    this.$viewToggle = this.$el.find('[data-collection-view]');
    this.$gridContainer = this.$el.find('.productgrid--outer');

    this._changeSorting = this._changeSorting.bind(this);
    this._changeSortingButton = this._changeSortingButton.bind(this);
    this._showSortModal = this._showSortModal.bind(this);
    this._showFiltersModal = this._showFiltersModal.bind(this);
    this._activateTag = this._activateTag.bind(this);
    this._advancedTags = this._advancedTags.bind(this);
    this._toggleTags = this._toggleTags.bind(this);

    this._toggleView = this._toggleView.bind(this);
    this._checkListView = this._checkListView.bind(this);

    this.events = [
      this.$sortTrigger.on('change.collection', this._changeSorting),
      this.$sortTriggerButton.on('click.collection', this._changeSortingButton),
      this.$sortTriggerModal.on('click.collection', this._showSortModal),
      this.$filtersTrigger.on('click.collection', this._showFiltersModal),
      this.$advandedTags.on('click.collection', this._advancedTags),
      this.$allTags.on('click.collection', this._activateTag),
      this.$additionalTags.on('click.collection', this._toggleTags),
      this.$viewToggle.on('click.collection', this._toggleView),
    ];

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(
        new ProductGridItem({
          el: productItem,
          id: this.section.id,
        }),
      );
    });

    this._setSortByQueryParameters();
    this._checkListView();
    this._updatePrices();
    this.modal = new Modal();
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.collection'));
    this.modal.unload();

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }

  /**
   * Set product grid prices to match CurrencyConverter settings on page load, section re-load
   *
   * @private
   */
  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }

  /**
   * Open Tags/Filters modal (on mobile)
   *
   * @param event
   * @private
   */
  _showFiltersModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.filtersContentSelector, 'productgrid-filters');
  }

  /**
   * Open Sort by modal (on mobile)
   *
   * @param event
   * @private
   */
  _showSortModal(event) {
    event.preventDefault();

    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.sortContent, 'productgrid-sort');
  }

  /**
   * Style a tag as active after click, before page transition
   *
   * @param event
   * @private
   */
  _activateTag(event) {
    $(event.target)
      .closest('.filter-item')
      .toggleClass('filter-item--active')
      .toggleClass('filter-item--inactive');
  }

  /**
   * Used by advanced tags to concatenate tag searches
   *
   * @param event
   * @private
   */
  _advancedTags(event) {
    event.preventDefault();
    const $target = $(event.currentTarget).parent();
    const targetGroup = $target.attr('data-group');

    const $filtersContent = $target.closest('nav');

    const filterGroups = $filtersContent.find('[data-filter-group]');
    const filterHandles = [];

    // Build the filter for the url based on what is in the dom
    filterGroups.each((index, filterGroup) => {
      if (filterGroup.getAttribute('data-filter-group') === targetGroup) {
        if (!$target.hasClass('filter-item--active')) {
          $target.siblings().removeClass('filter-item--active').addClass('filter-item--inactive');
          filterHandles.push($target.data('handle'));
        }
        // The active class is removed from the target in _activateTag
      } else {
        const selectedItems = filterGroup.querySelectorAll('.filter-item--active');
        if (selectedItems.length) {
          filterHandles.push($(selectedItems).data('handle'));
        }
      }
    });

    location.href = `${this.collectionUrl}/${filterHandles.join('+')}`;
  }

  /**
   * Expand / Collapse additional tags in the sidebar
   *
   * @param event
   * @private
   */
  _toggleTags(event) {
    event.preventDefault();

    const $trigger = $(event.currentTarget);
    const $items = $trigger.parent().siblings('[data-hidden-default]');
    const siblingsVisible = $trigger.data('filter-toggle');

    $items.toggleClass('filter-item--hidden', siblingsVisible);
    $trigger
      .data('filter-toggle', !siblingsVisible)
      .text(!siblingsVisible ? this.context.see_less : this.context.see_more);

    if (this.modal.isOpen()) {
      this.modal.position();
    }
  }

  /**
   * Make Shopify aware of releavent collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (let i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  /**
   * Sort by opens a modal on mobile, this handles button events
   *
   * @param event
   * @private
   */
  _changeSortingButton(event) {
    const activeClass = 'utils-sortby--modal-button--active';

    $(event.currentTarget)
      .addClass(activeClass)
      .parent()
      .siblings()
      .find(`.${activeClass}`)
      .removeClass(activeClass);

    this._changeSorting(event);
  }

  /**
   * Change sorting of collection
   *
   * @param event
   * @private
   */
  _changeSorting(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);

    Shopify.queryParams.sort_by = $target.val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * Toggle grid or list view
   *
   */
  _toggleView(event) {
    const $target = $(event.currentTarget);
    Shopify.queryParams.grid_list = $target.data('collection-view');
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  /**
   * Check grid/list view toggle query parameters
   *
   */
  _checkListView() {
    const view = Shopify.queryParams.grid_list ? Shopify.queryParams.grid_list : 'grid-view';
    this.$el.find('[href*="&grid_list"]')
      .attr('href',
        (i, href) => {
          if (href.indexOf('?') < 0) {
            const replaceIndex = href.indexOf('&');
            const firstHalf = href.substr(0, replaceIndex);
            const secondHalf = href.substr(replaceIndex+1);

            href = firstHalf.concat('?', secondHalf);
          }
          href = href.replace('grid_list', `grid_list=${view}`);
          return href;
        });

    this.$el.find('.utils-viewtoggle-button').removeClass('active');
    $(`[data-collection-view=${view}]`).addClass('active');
    const className = view.replace('-', '');
    this.$gridContainer.addClass(`productgrid-${className}`);
  }
}
